export default {
    baseStyle: {
        item: {
            flex: 1
        }
    }
}
